import { createBrowserHistory } from "history";

export const history = createBrowserHistory();

/**
 * Changes the url without refreshing the page.
 *
 * @param {string} url
 */
export function changeUrl(url) {
	history.push(url);
}

/**
 * Reads a query param and drops it from the address bar, so a back press or refresh can't replay it.
 *
 * @param {string} name
 * @returns {string|null}
 */
export function consumeQueryParam(name) {
	const params = new URLSearchParams(window.location.search);
	const value = params.get(name);
	if (value === null) {
		return null;
	}

	params.delete(name);
	const search = params.toString();
	window.history.replaceState(null, "", window.location.pathname + (search ? `?${search}` : ""));
	return value;
}

/**
 * Gets the base url of the website.
 *
 * @returns {string}
 */
export function getBaseUrl() {
	var getUrl = window.location;
	var baseUrl = getUrl.protocol + "//" + getUrl.host;

	return baseUrl;
}
